module.exports = __webpack_public_path__ + "static/media/logo1.33e78534.png";